module.exports = {
      id: "icon-trash-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-trash",
      toString: function () {
        return this.url;
      }
    }